var render = function render(){var _vm=this,_c=_vm._self._c;return _c('modal',{attrs:{"name":"language-settings","width":300,"height":150}},[_c('div',{attrs:{"id":"language-settings-modal"}},[_c('h1',[_vm._v("Language / Jazyk")]),_c('IconTimes',{staticClass:"close-modal",nativeOn:{"click":function($event){return _vm.$modal.hide('language-settings')}}}),_c('SwitchLanguage')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }